import React, { memo, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Button, CircularProgress, Dialog } from '@mui/material';

import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import { useStyles } from './campaign-select.style';
import CampaignList from './campaign-list';
import { CampaignItem } from 'src/app/modules/PruleadInsightsReporting/types/insights-types';
import { useCampaignSelect } from './campaign-select.hook';

type ComponentProps = ParamsProps & {
  onRowSelected: (campaign: CampaignItem | null) => void;
  onChange: (campaign: CampaignItem) => void;
  isView: boolean;
  selectedId: string;
};


export const CampaignSelect: React.FC<ComponentProps> = memo((props: ComponentProps) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });

  const { classes } = useStyles();
  const styles = useMemo(() => classes, [classes]);

  const { onRowSelected, onChange, isView, selectedId } = props;
  const { popUpVisible, isLoading, selectedRowsState, setSelectedRowsState, onCancel, onSelect, onSubmit } = useCampaignSelect({
    onSelectItem: onRowSelected,
    onChange: onChange,
    selectedId,
  });

  return (
    <div className={styles.container}>
      <div className={styles.buttonContainer}>
        {isLoading ? (
          <CircularProgress size={20} aria-label={Translation('common.loading')} />
        ) : (
          (selectedRowsState || selectedId) && (
            <span className={styles.content}>{selectedRowsState?.name || selectedId}</span>
          )
        )}

        {!selectedRowsState && !isView && (
          <Button color="secondary" variant="contained" onClick={onSelect} disabled={isLoading}>
            {Translation('deeplink.select.campaign')}
          </Button>
        )}

        {!!selectedRowsState && !isView && (
          <Button color="secondary" variant="contained" onClick={onSelect}>
            {Translation('deeplink.clear.select.event.label')}
          </Button>
        )}
      </div>

      <Dialog open={popUpVisible} onClose={onCancel} fullScreen>
        <>
          <div className={styles.backButtonContainer}>
            <Button onClick={onCancel} className={styles.backButton} variant="contained">
              {Translation('global.back.btnText')}
            </Button>
          </div>
          <div className={styles.tableContainer}>
            <CampaignList
              selectedRow={selectedRowsState}
              onRowSelected={setSelectedRowsState}
            />
          </div>

          <div className={styles.modalButtons}>
            <Button onClick={onCancel} className={styles.modalButton} variant="contained">
              {Translation('app.button.cancel')}
            </Button>
            <Button onClick={onSubmit} className={styles.modalButton} variant="contained" color="secondary">
              {Translation('app.button.submit')}
            </Button>
          </div>
        </>
      </Dialog>
    </div>
  );
});
